'use client';

import { c as _c } from "react/compiler-runtime";
import { fundingAmountValidation } from '@morfi/onramp-sdk';
import type { useFundingAmountDraft, useFundingInlineCheckout } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { FundingAmount } from './amount/funding-amount';
import { FundingCheckoutFeedback } from './funding-checkout-feedback';
import { FundingLimitRecovery } from './funding-limit-recovery';
import { FundingProviderFrame } from './funding-provider-frame';
export function FundingCheckoutAmount(t0) {
  const $ = _c(41);
  const {
    checkout,
    amountDraft,
    provider
  } = t0;
  const t = useTranslations("onramp");
  if (!(checkout.amountEntry || checkout.method !== "card" && checkout.method !== "sepa" && checkout.paymentSignature) || !checkout.method) {
    return null;
  }
  const t1 = !checkout.amountEntry;
  let t2;
  if ($[0] !== checkout.preview.review || $[1] !== checkout.purchase) {
    t2 = checkout.purchase ? {
      purchase: checkout.purchase,
      purchaseReview: checkout.preview.review
    } : {};
    $[0] = checkout.preview.review;
    $[1] = checkout.purchase;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = checkout.preview.review?.estimate ?? null;
  let t4;
  if ($[3] !== checkout) {
    t4 = checkout.preview.providerFailure?.amountBoundary ? null : fundingAmountValidation(checkout);
    $[3] = checkout;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] !== checkout) {
    t5 = <FundingCheckoutFeedback checkout={checkout} />;
    t6 = !checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : null;
    $[5] = checkout;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== checkout || $[12] !== provider || $[13] !== t) {
    t8 = checkout.method !== "card" && checkout.method !== "sepa" && checkout.paymentSignature && checkout.attemptId ? <div className="relative"><div className={!checkout.walletReady ? "absolute inset-0 opacity-0 pointer-events-none" : undefined} hidden={checkout.limitRecovery.blocked} inert={!checkout.paymentEnabled} aria-disabled={!checkout.paymentEnabled}><FundingProviderFrame key={checkout.attemptId} provider={provider} checkout={checkout} mode="payment" /></div>{checkout.limitRecovery.blocked && checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : null}{checkout.limitRecovery.blocked && !checkout.limitRecovery.canVerify ? <AnimatedButton className="h-11 w-full" size="lg" disabled={true}>{t("amount_over_limit")}</AnimatedButton> : null}</div> : checkout.limitRecovery.blocked && checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : undefined;
    $[11] = checkout;
    $[12] = provider;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = checkout.limitRecovery.blocked && !checkout.limitRecovery.canVerify;
  const t10 = checkout.canContinueAmount && !checkout.busy;
  let t11;
  if ($[15] !== checkout) {
    t11 = units => {
      checkout.quoteAmount(units);
    };
    $[15] = checkout;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== amountDraft.setValue || $[18] !== amountDraft.value || $[19] !== checkout.amountBoundary || $[20] !== checkout.amountLocked || $[21] !== checkout.changeMethod || $[22] !== checkout.currency || $[23] !== checkout.decimals || $[24] !== checkout.displayedLimits || $[25] !== checkout.method || $[26] !== checkout.preparingWallet || $[27] !== checkout.presets || $[28] !== checkout.previewAmount || $[29] !== t10 || $[30] !== t11 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t12 = <FundingAmount {...t2} method={checkout.method} currency={checkout.currency} decimals={checkout.decimals} value={amountDraft.value} presets={checkout.presets} estimate={t3} validationError={t4} limits={checkout.displayedLimits} recovery={t7} primaryAction={t8} allowanceBlocked={t9} amountBoundary={checkout.amountBoundary} quoteLoading={checkout.preparingWallet} onAmountChange={checkout.previewAmount} canContinue={t10} pending={checkout.amountLocked} onValueChange={amountDraft.setValue} onChangeMethod={checkout.changeMethod} onContinue={t11} />;
    $[17] = amountDraft.setValue;
    $[18] = amountDraft.value;
    $[19] = checkout.amountBoundary;
    $[20] = checkout.amountLocked;
    $[21] = checkout.changeMethod;
    $[22] = checkout.currency;
    $[23] = checkout.decimals;
    $[24] = checkout.displayedLimits;
    $[25] = checkout.method;
    $[26] = checkout.preparingWallet;
    $[27] = checkout.presets;
    $[28] = checkout.previewAmount;
    $[29] = t10;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t1 || $[39] !== t12) {
    t13 = <div hidden={t1}>{t12}</div>;
    $[38] = t1;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
}